export default __webpack_public_path__ + "static/media/137.a41d2dc5.jpg";